var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pg-404",attrs:{"id":"404"}},[_c('div',{staticClass:"section-wrapper"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("The page you are looking for was not found.")]),_c('div',[_c('router-link',{staticClass:"btn-links bg-primary",attrs:{"to":{ name: 'Home'}}},[_vm._v(" Return Home ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }